import gql from 'graphql-tag';

export const QUERY_PRODUCT_BY_SKU = gql`query QueryProductBySKU($sku: ID!) {
  product(idType: variationSKU, id: $sku) {
    databaseId
    slug
    name
    type
    link
    image {
      sourceUrl(size: SHOP_THUMBNAIL)
    }
    link
    ... on SimpleProduct {
      price
      uri
    }
    ... on VariableProduct {
      id
      name
      regularPrice
      uri
    }
  }
}
`;
export default QUERY_PRODUCT_BY_SKU;